import React, { useState } from "react";
import EwalletTiles from "../../components/Ggwallet/EwalletTiles";
import EwalletTilesSkeleton from "../../components/Ggwallet/EwalletTilesSkeleton";
import InvestGGFC from "../../components/Ggwallet/InvestGGFC";
import WithdrawGGFC from "../../components/Ggwallet/WithdrawGGFC";
import InvestmentReport from "../../components/Ggwallet/InvestmentReport";
import WithdrawalReport from "../../components/Ggwallet/WithdrawalReport";
import { NavLink,Link } from "react-router-dom";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import TableMain from "../../components/Common/table/TableMain";

const RealWalletLayout = () => {
  const [showTransfer, setShowTransfer] = useState(false);
  const [showInvestModal, setShowInvestModal] = useState(false);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  // Removed statement pagination & state as Statement tab deprecated
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("investment_report");


  const ewallet = ApiHook.CallGgwalletTiles();
  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );

  // setApiTab removed (was for statement reload)

  const handleInvestGGFC = () => {
    setShowInvestModal((prevShow) => !prevShow);
  };

  const handleWithdrawGGFC = () => {
    setShowWithdrawModal((prevShow) => !prevShow);
  };

  return (
    <>
      <div className="page_head_top"> GGFC wallet</div>
      <div className="ewallet_top_btn_sec">
        <div className="row justify-content-between">
          <div className="col-md-4">
            <NavLink to={"/e-wallet"} className="btn_ewallt_page">
              {t("ewallet")}
            </NavLink>
            <NavLink to={"/real-wallet"} className="btn_ewallt_page">
            Real Estate Wallet
            </NavLink>
            <NavLink className="btn_ewallt_page" activeclassname="active">
              GGFC wallet
            </NavLink>
            <NavLink to={"/lottery-wallet"} className="btn_ewallt_page">
              Game Wallet
            </NavLink>
          </div>
          <div className="col-md-4 text-end">
            <button
              className="btn btn-primary invest-ggfc-btn me-2"
              onClick={handleInvestGGFC}
              style={{
                backgroundColor: "#32009c",
                border: "none",
                borderRadius: "25px",
                padding: "8px 20px",
                fontSize: "14px",
                fontWeight: "500"
              }}
            >
              {t("invest_ggfc")}
            </button>
            <button
              className="btn btn-danger withdraw-ggfc-btn"
              onClick={handleWithdrawGGFC}
              style={{
                backgroundColor: "#dc3545",
                border: "none",
                borderRadius: "25px",
                padding: "8px 20px",
                fontSize: "14px",
                fontWeight: "500"
              }}
            >
              {t("withdraw_ggfc")}
            </button>
          </div>
        </div>
      </div>
      
      {/* Wallet Tiles with Loading State */}
      {ewallet?.isLoading ? (
        <EwalletTilesSkeleton />
      ) : (
        <EwalletTiles
          tiles={ewallet?.data}
          currency={userSelectedCurrency}
          conversionFactor={conversionFactor}
          type="ggfc"
        />
      )}


      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="ewallet_table_section_cnt_tab_head">
            <Link 
              className={`ewallet_tab_btn ${activeTab === "investment_report" ? "active" : ""}`}
              onClick={() => setActiveTab("investment_report")}
            >
              {t("investment_report")}
            </Link>
            <Link 
              className={`ewallet_tab_btn ${activeTab === "withdrawal_report" ? "active" : ""}`}
              onClick={() => setActiveTab("withdrawal_report")}
            >
              {t("withdrawal_report")}
            </Link>
          </div>
        </div>

        {activeTab === "investment_report" && <InvestmentReport />}
        {activeTab === "withdrawal_report" && (
          <div className="withdrawal-report-container">
            <WithdrawalReport />
          </div>
        )}
      </div>

      <InvestGGFC
        balance={ewallet?.data?.withdrawlAmount}
        show={showInvestModal}
        handleClose={handleInvestGGFC}
        currency={userSelectedCurrency}
        contracts={ewallet?.data?.contracts}
        intrestPeriod={ewallet?.data?.intrestPeriod}
        bitgoWallet={ewallet?.data?.bitgoWallet ?? null}
      />

      <WithdrawGGFC
        balance={ewallet?.data?.withdrawlAmount}
        minWithdrawTokenAmount={ewallet?.data?.minWithdrawTokenAmount}
        show={showWithdrawModal}
        handleClose={handleWithdrawGGFC}
        currency={userSelectedCurrency}
        walletWithdrawalInfo={ewallet?.data?.regInvest}
        regAmountWithdraw={ewallet?.data?.regAmountWithdraw}
        withdrawalFee={ewallet?.data?.withdrawalFee} 
      />
    </>
  );
};

export default RealWalletLayout;
